// components/Header.js
import React from "react";
import { chakra as c, HStack, Link as ChakraLink, Image, Text, Box, VStack, IconButton, useDisclosure} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';

const Navigation = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box>
      {/* ハンバーガーアイコン（スマホだけ表示） */}
      <IconButton
        display={{ base: "inline-flex", md: "none" }}
        icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
        aria-label="メニューを開く"
        variant="ghost"
        onClick={isOpen ? onClose : onOpen}
        fontSize="20px"
      />

      {/* ナビゲーション（PC用：横並び） */}
      <HStack
        as="nav"
        spacing={6}
        fontSize={{ base: "sm", md: "md", lg: "lg" }}
        display={{ base: "none", md: "flex" }}
      >
        <ChakraLink href="#features" _hover={{ color: "brand.500" }}>
          特徴
        </ChakraLink>
        <ChakraLink href="#plans" _hover={{ color: "brand.500" }}>
          料金プラン
        </ChakraLink>
        <ChakraLink href="#faq" _hover={{ color: "brand.500" }}>
          よくある質問
        </ChakraLink>
        <ChakraLink href="#contact" _hover={{ color: "brand.500" }}>
          お問い合わせ
        </ChakraLink>
      </HStack>

      {/* ナビゲーション（スマホ用：縦並びのドロップダウン） */}
      {isOpen && (
        <VStack
          as="nav"
          spacing={4}
          mt={4}
          align="start"
          fontSize="sm"
          display={{ base: "flex", md: "none" }}
        >
          <ChakraLink href="#features" _hover={{ color: "brand.500" }} onClick={onClose}>
            特徴
          </ChakraLink>
          <ChakraLink href="#plans" _hover={{ color: "brand.500" }} onClick={onClose}>
            料金プラン
          </ChakraLink>
          <ChakraLink href="#faq" _hover={{ color: "brand.500" }} onClick={onClose}>
            よくある質問
          </ChakraLink>
          <ChakraLink href="#contact" _hover={{ color: "brand.500" }} onClick={onClose}>
            お問い合わせ
          </ChakraLink>
        </VStack>
      )}
    </Box>
  );
};

export default function Header() {
  return (
    <c.header
      bg="white"
      borderBottom="1px solid"
      borderBottomColor="gray.200"
      py={4}
      px={{ base: 4, md: 8 }}
    >
      <c.div
        maxW="1500px"
        mx="auto"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        {/* ロゴ（アイコン上、Manary 下の2段構成） */}
        <c.div
          display="flex"
          alignItems="center"
          fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
          color="brand.500"
        >
          <Image src="/favicon.ico" alt="Manary Icon" boxSize={{base: "70px",md: "80px",
          lg: "100px",xl: "124px"}} mb={2} />
            <Text fontFamily='"Chalkboard SE", "Comic Sans MS", cursive'>
              Manary
              </Text>
        </c.div>

        <Navigation />

        {/* ナビゲーション
        <HStack as="nav" spacing={6} fontSize={{ base: "sm", md: "md", lg: "lg" }}>
          <ChakraLink href="#features" _hover={{ color: "brand.500" }}>
            特徴
          </ChakraLink>
          <ChakraLink href="#plans" _hover={{ color: "brand.500" }}>
            料金プラン
          </ChakraLink>
          <ChakraLink href="#faq" _hover={{ color: "brand.500" }}>
            よくある質問
          </ChakraLink>
          <ChakraLink href="#contact" _hover={{ color: "brand.500" }}>
            お問い合わせ
          </ChakraLink>
        </HStack> */}

      </c.div>
    </c.header>
  );
}
